/**
 * Configuration for Stytch B2B authentication
 * This app is configured to use B2B authentication only
 */

export const AUTH_CONFIG = {
  // B2B mode is always enabled in this implementation
  isB2B: true,

  // // Default organization settings for B2B
  // defaultOrganizationSlug: "groq",
  // defaultOrganizationId: "org_123", // TODO: Update with actual org ID

  // Session configuration
  sessionDurationMinutes: 60 * 24 * 30, // 30 days

  // Redirect URLs
  getLoginRedirectUrl: (domain: string) => `${domain}/authenticate`,
  getSignupRedirectUrl: (domain: string) => `${domain}/authenticate`,
  getDiscoveryRedirectUrl: (domain: string) => `${domain}/authenticate`,
  getAutoCloseUrl: (domain: string) =>
    `${domain}/authenticate/login/login-self-close`,
} as const;

// Export convenience flag for backwards compatibility
export const isStytchB2BEnabled = AUTH_CONFIG.isB2B;
